import {appName} from "../constants";

function getPrefixedKey(key) {
    return `${appName}.${key}`
}

export { getPrefixedKey }
